import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ag-page_assets position-relative" }
const _hoisted_2 = {
  class: "form-group p-4",
  style: {"width":"25%","padding-bottom":"0px !important"}
}
const _hoisted_3 = { for: "type" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "server" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { for: "port" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "email" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_16 = ["rules"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "password" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "apiKey" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "email" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_27 = ["rules"]
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, { module: _ctx.module }, {
      "smtp-settings": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t("type")) + " ", 1),
            _hoisted_4
          ]),
          _withDirectives(_createElementVNode("select", {
            name: "type",
            id: "",
            maxlength: "191",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formType) = $event)),
            class: "form-control"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, key) => {
              return (_openBlock(), _createElementBlock("option", {
                key: key,
                value: item.key
              }, _toDisplayString(item.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.formType]
          ])
        ]),
        (_openBlock(), _createBlock(_component_Form, {
          class: "p-4 pt-0",
          onSubmit: _ctx.onSubmit,
          key: _ctx.compKey,
          ref: "form",
          "validation-schema": _ctx.formType === 'smtp' ? _ctx.schema : _ctx.schemeSendGrid,
          "initial-values": _ctx.formValues
        }, {
          default: _withCtx(({ meta }) => [
            (_ctx.formType === 'smtp')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_Field, { name: "server" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, [
                          _createTextVNode(_toDisplayString(_ctx.$t("server")) + " ", 1),
                          _hoisted_9
                        ]),
                        _createElementVNode("input", _mergeProps({
                          name: "server",
                          type: "text",
                          maxlength: "191"
                        }, field, {
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "server"
                        }), null, 16),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "server"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Field, { name: "port" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.$t("port")) + " ", 1),
                          _hoisted_12
                        ]),
                        _createVNode(_component_Field, _mergeProps({
                          name: "port",
                          type: "number",
                          maxlength: "191",
                          step: "1",
                          required: ""
                        }, field, {
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "port"
                        }), null, 16, ["class"]),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "port"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Field, { name: "email" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.$t("smtpEmail")) + " ", 1),
                          _hoisted_15
                        ]),
                        _createElementVNode("input", _mergeProps({
                          name: "email",
                          maxlength: "191",
                          type: "email"
                        }, field, {
                          rules: _ctx.validateEmail,
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "email"
                        }), null, 16, _hoisted_16),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "email"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Field, { name: "password" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.$t("smtpPassword")) + " ", 1),
                          _hoisted_19
                        ]),
                        _createElementVNode("input", _mergeProps({
                          name: "password",
                          type: "password"
                        }, field, {
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "password"
                        }), null, 16),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "password"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (_ctx.formType === 'sendgrid')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_Field, { name: "apiKey" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, [
                          _createTextVNode(_toDisplayString(_ctx.$t("apiKey")) + " ", 1),
                          _hoisted_23
                        ]),
                        _createElementVNode("input", _mergeProps({
                          name: "apiKey",
                          type: "text",
                          maxlength: "191"
                        }, field, {
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "apiKey"
                        }), null, 16),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "apiKey"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Field, { name: "email" }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, [
                          _createTextVNode(_toDisplayString(_ctx.$t("smtpEmail")) + " ", 1),
                          _hoisted_26
                        ]),
                        _createElementVNode("input", _mergeProps({
                          name: "email",
                          maxlength: "191",
                          type: "email"
                        }, field, {
                          rules: _ctx.validateEmail,
                          class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                          id: "email"
                        }), null, 16, _hoisted_27),
                        _createVNode(_component_error_message, {
                          class: "form-error-label",
                          name: "email"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              disabled: !meta.valid,
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
            }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_28)
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"]))
      ]),
      _: 1
    }, 8, ["module"])
  ]))
}